// extracted by mini-css-extract-plugin
module.exports = {"Tagline":"ContactTagline_Tagline__3ZGUY","Container":"ContactTagline_Container__2rDjv","Clone":"ContactTagline_Clone__2ayaQ"};